<!---job list -->
<div class="dashboard_bred_crumb" *ngIf="!listingBlock">
  <ul>
    <li> <a [routerLink]="['/profile/my-dashboard']" routerLinkActive="active-link">Home</a> </li>
    <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
    <li><a [routerLink]="['/profile/job-listing']" routerLinkActive="active-link">Job listing</a></li>
  </ul>
</div>

<section class="dashboard_content_sec" *ngIf="!listingBlock">
  <section class="master_add_sec filterSec bgW_borRed">
    <div style="display: flex; flex-wrap: wrap; align-items:center;">
      <div class="job_head">
        Job Profiles
      </div>
      <div class="create-job-btn" *ngIf="loginDetails.type !== 'ADMIN' && showCreateButton">
        <button (click)="handleCreateJobClick()" type="submit" class="btn btn-sm global-btn mat-button" mat-button>
          Create New Job
        </button>
      </div>
      <!-- <button type="button" class="btn btn-sm global-btn mat-button" mat-button
            [routerLink]="['../add']">Add Client</button>-->
    </div>
    <form class="form-section">
      <div class="filterJoblist aligned-container"
        *ngIf="loginDetails.type === 'ADMIN' || loginDetails.type === 'SUPPLIER' || loginDetails.type === 'PRACTICE'">
        <div class="job-status-tabs">
          <button type="button" class="status-tab" [class.active]="selectedStatus === 'ALL'"
            (click)="selectStatus('ALL')">
            All <span class="count-badge">{{ jobsTabCounts?.ALL || 0 }}</span>
          </button>

          <button type="button" class="status-tab" [class.active]="selectedStatus === 'DRAFT'"
            (click)="selectStatus('DRAFT')" *ngIf="loginDetails.type !== 'ADMIN'">
            Draft <span class="count-badge">{{ jobsTabCounts?.DRAFT || 0 }}</span>
          </button>

          <button type="button" class="status-tab" [class.active]="selectedStatus === 'PENDING'"
            (click)="selectStatus('PENDING')">
            Pending <span class="count-badge">{{ jobsTabCounts?.PENDING || 0 }}</span>
          </button>

          <button type="button" class="status-tab" [class.active]="selectedStatus === 'ACTIVE'"
            (click)="selectStatus('ACTIVE')" *ngIf="loginDetails.type !== 'ADMIN'">
            Active <span class="count-badge">{{ jobsTabCounts?.ACTIVE || 0 }}</span>
          </button>

          <button type="button" class="status-tab" [class.active]="selectedStatus === 'INACTIVE'"
            (click)="selectStatus('INACTIVE')" *ngIf="loginDetails.type !== 'ADMIN'">
            Inactive <span class="count-badge">{{ jobsTabCounts?.INACTIVE || 0 }}</span>
          </button>

          <button type="button" class="status-tab" [class.active]="selectedStatus === 'EXPIRED'"
            (click)="selectStatus('EXPIRED')">
            <!-- (click)="selectStatus('EXPIRED')" *ngIf="loginDetails.type !== 'ADMIN'"> -->
            Expired <span class="count-badge">{{ jobsTabCounts?.EXPIRED || 0 }}</span>
          </button>

          <button type="button" class="status-tab" [class.active]="selectedStatus === 'APPROVE'"
            (click)="selectStatus('APPROVE')" *ngIf="loginDetails.type === 'ADMIN'">
            Approved <span class="count-badge">{{ jobsTabCounts?.APPROVE || 0 }}</span>
          </button>

          <button type="button" class="status-tab" [class.active]="selectedStatus === 'REJECT'"
            (click)="selectStatus('REJECT')">
            Rejected <span class="count-badge">{{ jobsTabCounts?.REJECTED || 0 }}</span>
          </button>
        </div>




        <div class="search-box" *ngIf="loginDetails.type === 'ADMIN'" style="text-align: end !important;">
          <button type="button" mat-button class="table-filter-btn" (click)="filterToggle(); $event.stopPropagation()">
            <img *ngIf="!OpenFilter" src="assets/images2/Funnel.svg" alt="" width="16" height="16"
              style="margin-right: 5px;" class="filter-icon" />
            <mat-icon *ngIf="OpenFilter" style="margin-right:8px;">close</mat-icon>
            Filter
          </button>
        </div>

        <section *ngIf="OpenFilter" class="basic-filter openclose-filter-sec" (click)="$event.stopPropagation()">
          <div class="filter-row">



            <!-- Filter Company -->

            <div class="dropdown-container">
              <mat-form-field appearance="outline">
                <mat-label>Company</mat-label>
                <input matInput placeholder="Search Company" [formControl]="companyCtrl"
                  (focus)="showCompanyDropdown = true" (blur)="hideDropdown('company')">
              </mat-form-field>

              <div *ngIf="showCompanyDropdown && companies.length" class="dropdown-list">
                <cdk-virtual-scroll-viewport itemSize="40" class="dropdown-viewport"
                  (scrolledIndexChange)="onCompanyScrolled()">
                  <div *cdkVirtualFor="let company of companies" class="dropdown-item"
                    (click)="selectCompany(company.company_name)">
                    {{ company.company_name }}
                  </div>
                </cdk-virtual-scroll-viewport>
              </div>
            </div>

            <!-- Filter Role  -->
            <div class="dropdown-container">
              <mat-form-field appearance="outline">
                <mat-label>Role</mat-label>
                <input matInput placeholder="Search Role" [formControl]="roleCtrl" (focus)="showRoleDropdown = true"
                  (blur)="hideDropdown('role')">
              </mat-form-field>

              <div *ngIf="showRoleDropdown && roles.length" class="dropdown-list">
                <cdk-virtual-scroll-viewport itemSize="40" class="dropdown-viewport"
                  (scrolledIndexChange)="onRoleScrolled()">

                  <div *cdkVirtualFor="let role of roles" class="dropdown-item" (click)="selectRole(role.j_role)">
                    {{ role.j_role }}
                  </div>
                </cdk-virtual-scroll-viewport>
              </div>
            </div>

            <!--  status option -->
            <div class="dropdown-container" *ngIf="selectedStatus === 'ALL'">
              <mat-form-field appearance="outline">
                <mat-label>Status</mat-label>
                <input matInput placeholder="Search Status" [formControl]="statusCtrl"
                  (focus)="showStatusDropdown = true" (blur)="hideDropdown('status')">
              </mat-form-field>

              <div *ngIf="showStatusDropdown && statusOptions.length" class="dropdown-list">
                <cdk-virtual-scroll-viewport #statusViewport itemSize="40" class="dropdown-viewport"
                  (scrolledIndexChange)="onStatusScrolled()">

                  <div *cdkVirtualFor="let status of statusOptions" class="dropdown-item"
                    (click)="selectFilterStatus(status.status)">
                    {{ status.status }}
                  </div>
                </cdk-virtual-scroll-viewport>
              </div>
            </div>


            <!-- employeeType option -->
            <div class="dropdown-container">
              <mat-form-field appearance="outline">
                <mat-label>Employee Type</mat-label>
                <input matInput placeholder="Search Employee Type" [formControl]="empTypeCtrl"
                  (focus)="showEmpTypeDropdown = true" (blur)="hideDropdown('empType')">
              </mat-form-field>

              <div *ngIf="showEmpTypeDropdown && empTypeOptions.length" class="dropdown-list">
                <cdk-virtual-scroll-viewport #empTypeViewport itemSize="40" class="dropdown-viewport"
                  (scrolledIndexChange)="onEmpTypeScrolled()">
                  <div *cdkVirtualFor="let emp of empTypeOptions" class="dropdown-item" (click)="selectEmpType(emp)">
                    {{ emp }}
                  </div>
                </cdk-virtual-scroll-viewport>
              </div>
            </div>



            <!-- Clear Button -->
            <button mat-button class="clear-btn" type="button" (click)="clearAllFilters()">Clear</button>

          </div>
        </section>

      </div>
    </form>
  </section>

  <!---jobList Item-->
  <div class="job-list-container" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="150"
    (scrolled)="onScroll()">

    <div *ngIf="loaderJobList" class="custom-loader custom_logo_loader no-datas">
                            <img src='../../../../../assets/images2/loader.gif' alt="loading" style="width: 10%;" />
                        </div>

    <ng-container *ngIf="!loaderJobList">
      <ng-container *ngIf="jobList?.length > 0; else noData">
        <section class="master_add_sec" *ngFor="let x of jobList; trackBy: trackByJobId">
          <mat-card class="job-card" fxLayout="column" fxLayoutGap="16px"
            [ngClass]="{ 'highlight-row': x.id === receivedId }"
            >
            <!-- Row: Avatar + Content -->
            <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
              <div class="avatar">
                <img *ngIf="x?.logo" [src]="x.logo" loading="lazy" />
              </div>
    
    
              <div fxFlex class="content-box" fxLayout="column" fxLayoutAlign="start start">
                <!-- Top Row -->
                <div fxLayout="row" fxLayoutAlign="space-between center" class="top-row">
                  <div class="title">
                    <strong class="title_head">{{x.title}}</strong>
                    <span class="date">• Posted on : {{x.created_at | date : 'dd-MM-yyyy'}}</span>
                  </div>
    
                  <!-- Status + Menu -->
                  <!-- Status + Menu Button -->
                  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px" class="status-menu">
                    <div *ngIf="x?.status" class="dynamic-status-badges" fxLayout="row" fxLayoutGap="8px">
                      <div *ngIf="x?.status === 'DRAFT'" class="status-badge draft">DRAFT</div>
    
                      <div
                        *ngIf="x?.status === 'APPROVE' && x?.active_status === 'ACTIVE' && loginDetails?.type !== 'PROFESSIONAL'"
                        class="status-badge active">
                        ACTIVE
                      </div>
    
                      <div *ngIf="x?.status === 'APPROVE' && x?.active_status === 'INACTIVE'" class="status-badge inactive">
                        INACTIVE
                      </div>
    
                      <div *ngIf="x?.status === 'PENDING'" class="status-badge pending">PENDING</div>
    
                      <div *ngIf="x?.status === 'REJECT'" class="status-badge rejected">REJECTED</div>
    
                      <div *ngIf="x?.status === 'EXPIRED'" class="status-badge expired">EXPIRED</div>
                    </div>
    
    
                    <!-- Menu Trigger Buttons -->
                    <ng-container *ngIf="loginDetails?.type !== 'ADMIN' && loginDetails?.type !== 'PROFESSIONAL'">
                      <button mat-icon-button [matMenuTriggerFor]="menuUser" class="menu-btn">
                        <mat-icon>more_horiz</mat-icon>
                      </button>
                      <mat-menu #menuUser="matMenu" class="custom-menu">
                        <!-- Preview -->
                        <button mat-menu-item (click)="viewJob(x.id)">
                          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                            <img src="assets/images2/view.svg" width="18" height="18" />
                            <span class="menu-label orange" style="font-size: 14px; font-weight: 600;">Preview</span>
                          </div>
                        </button>
    
                        <!-- Edit -->
                        <button mat-menu-item *ngIf="!['EXPIRED'].includes(x.status)" (click)="editJob(x)">
                          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                            <img src="assets/images2/edit.svg" width="18" height="18" />
                            <span class="menu-label blue">Edit</span>
                          </div>
                        </button>
    
                        <!-- Toggle Status -->
                        <button mat-menu-item *ngIf="x.active_status === 'ACTIVE' && x.status === 'APPROVE'"
                          (click)="updateStatus(x.id,'INACTIVE')">
                          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                            <img src="assets/images2/moon.svg" width="18" height="18" />
                            <span class="menu-label orange">Inactive</span>
                          </div>
                        </button>
    
                        <button mat-menu-item *ngIf="x.active_status === 'INACTIVE' && x.status === 'APPROVE' "
                          (click)="updateStatus(x.id,'ACTIVE')">
                          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                            <img src="assets/images2/moon.svg" width="18" height="18" />
                            <span class="menu-label green">Active</span>
                          </div>
                        </button>
    
                        <!-- Delete -->
                        <button mat-menu-item *ngIf="x.status === 'DRAFT' || x.status === 'PENDING' "
                          (click)="deleteJob(x)">
                          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                            <img src="assets/images2/trash.svg" width="18" height="18" />
                            <span class="menu-label red">Delete</span>
                          </div>
                        </button>

                        <!-- Relist -->
                        <button mat-menu-item *ngIf="x.status === 'EXPIRED'"
                          (click)="editJob(x)">
                          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                          <mat-icon color="primary">refresh</mat-icon>
                            <span class="menu-label blue">Relist</span>
                          </div>
                        </button>

                      </mat-menu>
                    </ng-container>
    
                    <!-- ADMIN Menu -->
                    <ng-container *ngIf="loginDetails?.type === 'ADMIN'">
                      <button mat-icon-button [matMenuTriggerFor]="menuAdmin" class="menu-btn">
                        <mat-icon>more_horiz</mat-icon>
                      </button>
                      <mat-menu #menuAdmin="matMenu" class="custom-menu">
                        <button mat-menu-item (click)="updateJobStatus( x.id ,'APPROVE')"
                          *ngIf="x.status !== 'APPROVE' && x.status !== 'EXPIRED' ">
                          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                            <i class="fa fa-check" style="font-size: 20px; color: green;"></i>
                            <span class="menu-label green">Approve</span>
                          </div>
                        </button>
                        <button mat-menu-item (click)="updateJobStatus(x.id ,'REJECT')"
                          *ngIf="x.status === 'PENDING' ">
                          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                            <mat-icon color="warn">cancel</mat-icon>
                            <span class="menu-label red">Reject</span>
                          </div>
                        </button>
                        <!-- <button mat-menu-item [routerLink]="['/jobseek/jobseeks/popular', x.id]">
                          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                            <img src="assets/images2/preview.svg" width="18" height="18" />
                            <span class="menu-label">Preview</span>
                          </div>
                        </button> -->
    
    
                        <button mat-menu-item (click)="viewJob(x.id)">
                          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                            <img src="assets/images2/view.svg" width="18" height="18" />
                            <span class="menu-label orange" style="font-size: 14px; font-weight: 600;">Preview</span>
                          </div>
                        </button>
    
                      </mat-menu>
                    </ng-container>
    
                    <!-- PROFESSIONAL Menu -->
                    <!-- <ng-container *ngIf="loginDetails?.type === 'PROFESSIONAL'">
                      <button mat-icon-button [matMenuTriggerFor]="menuPro" class="menu-btn">
                        <mat-icon>more_horiz</mat-icon>
                      </button>
                      <mat-menu #menuPro="matMenu" class="custom-menu">
                        <button mat-menu-item (click)="viewJob(x)">
                          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                            <img src="assets/images2/preview.svg" width="18" height="18" />
                            <span class="menu-label">Preview</span>
                          </div>
                        </button>
                      </mat-menu>
                    </ng-container> -->
                  </div>
    
                </div>
    
                <!-- Company Name -->
                <div class="company-name">{{x.company_name}}</div>
    
                <!-- Chips + Applicants -->
                <div fxLayout="row" fxLayoutAlign="space-between center" class="chip-row" >
                  <mat-chip-list class="chip-list" aria-label="Job Types">
                    <mat-chip *ngFor="let type of getJobTypes(x?.TypeofEmployment)" selected>
                      {{ type }}
                    </mat-chip>
                  </mat-chip-list>
    
                  <div style="display: flex;gap: 10px;" *ngIf="x?.status ==='APPROVE' || x?.status ==='PENDING' ||  x?.status ==='EXPIRED'" >
    
                    <span class="applicants" *ngIf="loginDetails.type !== 'PROFESSIONAL'"
                      [routerLink]="['/profile/job-listing/applicants', x.id, 'APPLICANT']">
                      {{
                      (x?.job_applicants_aggregate?.aggregate?.count || 0)
                      + ' '
                      + ((x?.job_applicants_aggregate?.aggregate?.count || 0) === 1 ? 'Applicant' : 'Applicants')
                      }}
    
                    </span>
    
                    <span class="applicants" *ngIf="loginDetails.type !== 'PROFESSIONAL'"
                      [routerLink]="['/profile/job-listing/applicants', x.id, 'ENQUIRY']">
                      {{
                      (x?.job_enquiries_aggregate?.aggregate?.count || 0)
                      + ' '
                      + ((x?.job_enquiries_aggregate?.aggregate?.count || 0) === 1 ? 'Enquiry' : 'Enquiries')
                      }}
    
                    </span>
                  </div>
                </div>
    
              </div>
            </div>
    
    
            <!-- Divider under avatar + content -->
            <div class="inner-divider"></div>
    
            <!-- Footer -->
            <div class="job-footer" fxLayout="column" fxLayoutGap="16px">
              <div *ngIf="x?.description">
                <div class="job-desc-heading">Job Description</div>
                <div class="description">
                  {{x.description}}
                </div>
              </div>
    
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <div class="action-buttons" fxLayout="row" fxLayoutGap="8px">
    
                </div>
                <div class="view-details" fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="center center"
                  [routerLink]="['/jobseek/jobseeks/popular', x.id]">
                  <span>View Details</span>
                  <mat-icon>chevron_right</mat-icon>
                </div>
              </div>
            </div>
          </mat-card>
        </section>
      </ng-container>

      <div *ngIf="loadingJobs && jobList.length > 0" class="loading-more" fxLayout="row"
                fxLayoutAlign="center center">
                <img src="../../../../../assets/images2/loader.gif" alt="Loading more..." loading="lazy" width="80px" />
            </div>

        <div *ngIf="!hasMoreJobs && !loadingJobs && jobList?.length > 0" class="text-center py-3 text-muted">
               You've reached the end — no more jobs to display
              </div>

    </ng-container>

   

      <ng-template #noData>
        <div class="no-data-wrapper">
          <img src="../../../../../assets/images/icons/no_tasks.svg" alt="No records illustration" class="no-data-image" />
          <div class="no-record-text">  No
            <span *ngIf="selectedStatus ==='APPROVE' ">approved</span>
            <span *ngIf="selectedStatus ==='REJECT' ">rejected</span>
            <span *ngIf="selectedStatus ==='PENDING' ">pending</span>
            <span *ngIf="selectedStatus ==='ACTIVE' "> active</span>
            <span *ngIf="selectedStatus ==='INACTIVE' ">inactive</span>
            <span *ngIf="selectedStatus ==='EXPIRED' ">expired</span>
            <span *ngIf="selectedStatus ==='DRAFT' ">draft</span> jobs available at the moment
          </div>
        </div>
      </ng-template>

  </div>
  <!---jobList Item end-->

</section>